__turbopack_context__.v({
  "action": "section-of-steps-module-scss-module__VTPTLa__action",
  "header": "section-of-steps-module-scss-module__VTPTLa__header",
  "icon": "section-of-steps-module-scss-module__VTPTLa__icon",
  "item": "section-of-steps-module-scss-module__VTPTLa__item",
  "item-1": "section-of-steps-module-scss-module__VTPTLa__item-1",
  "item-2": "section-of-steps-module-scss-module__VTPTLa__item-2",
  "item-3": "section-of-steps-module-scss-module__VTPTLa__item-3",
  "item-4": "section-of-steps-module-scss-module__VTPTLa__item-4",
  "item-interactive": "section-of-steps-module-scss-module__VTPTLa__item-interactive",
  "item-ordered": "section-of-steps-module-scss-module__VTPTLa__item-ordered",
  "item-skeleton": "section-of-steps-module-scss-module__VTPTLa__item-skeleton",
  "list": "section-of-steps-module-scss-module__VTPTLa__list",
  "list-ordered": "section-of-steps-module-scss-module__VTPTLa__list-ordered",
  "shimmer": "section-of-steps-module-scss-module__VTPTLa__shimmer",
});
